function MainLogo() {
    return (
            <div id="site-title">Bibliacra</div>
    );
}

export default MainLogo